import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Typography, Modal } from '@mui/material';

import { useNavigate } from 'react-router';
import { sendReservationConfirmationEmail } from '../api/Stripe';
import { sendDriverDocumentsRequests } from '../api/Product';
import { useVehicleReservation } from '../common/Providers/VehicleReservationProvider/UseVehicleReservation';
import { useResponsiveValues } from "../common/Providers/DimentionsProvider/UseResponsiveValues";

const Thankyou: React.FC = () => {

  const navigate = useNavigate();
  const { initVehicleReservation } = useVehicleReservation();
  const { matches900 } = useResponsiveValues();

  const name = localStorage.getItem('full-name');
  const id = parseInt(localStorage.getItem('_r_id') || '0');
  const order_number = localStorage.getItem('_r_order_number');
  const email = localStorage.getItem('_r_email');
  const phone_number = localStorage.getItem('_r_phone');
  const pickup = localStorage.getItem('_r_pickup');
  const dropoff = localStorage.getItem('_r_dropoff');
  const store_logo_path = localStorage.getItem('_r_logo_url');
  const store_name = localStorage.getItem('_r_store_name');

  useEffect(()=>{
    initVehicleReservation();

    if(!pickup || !dropoff){
      navigate('/rental');
    }

    const sendMail = setTimeout(()=>{
      const mailParams = { 
        id,
        name, 
        email,
        phone_number: phone_number,
        // store_logo_path: "https://api.bodhisys.io/uploads/img_1711075052760_Bikes To Go Logo.jpg",
        store_logo_path: store_logo_path,
        store_name: store_name,
        start_time: pickup,
        end_time: dropoff,
      }
      sendReservationConfirmationEmail(mailParams);

      if (id) {
        // Prepare drivers array: primary driver first, then additional drivers
        const drivers = [];
        
        // Add primary driver (logged-in user)
        drivers.push({
          name: name || '',
          email: email || '',
          phone: phone_number || ''
        });
        
        // Add additional drivers if they exist
        const additionalDriversStr = localStorage.getItem('_r_additional_drivers');
        if (additionalDriversStr) {
          try {
            const additionalDrivers = JSON.parse(additionalDriversStr);
            if (Array.isArray(additionalDrivers)) {
              additionalDrivers.forEach(driver => {
                drivers.push({
                  name: driver.name || '',
                  email: driver.email || '',
                  phone: driver.phone || ''
                });
              });
            }
          } catch (err) {
            console.error("Failed to parse additional drivers", err);
          }
        }
        
        sendDriverDocumentsRequests({
          reservation_id: id,
          drivers: drivers
        }).catch(err => console.error("Failed to send driver document requests", err));
      }
    }, 100);
    
    return () =>{
      clearTimeout(sendMail);
    }
  }, [])
  
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  
  const memoizedStyles = useMemo(() => styles(matches900), [matches900]);
  
  // setTimeout(()=>{
  //   localStorage.removeItem('_r_id');
  //   localStorage.removeItem('_r_order_number');
  //   localStorage.removeItem('_r_name');
  //   localStorage.removeItem('_r_email');
  //   localStorage.removeItem('_r_pickup');
  //   localStorage.removeItem('_r_dropoff');
  //   localStorage.removeItem('_r_logo_url');
  //   localStorage.removeItem('_r_store_name');
  // }, 5000);

  setTimeout(()=>{
    localStorage.clear();
  }, 2000);

  useEffect(()=>{
    // const accessToken = localStorage.getItem('access-token');
    // if(!accessToken) navigate('/');
  }, []);

  return (
<Modal
        open={isModalOpen}
        sx={memoizedStyles.modal}
      >
      <Box sx={{ p:'16px', backgroundColor:'#fff', flex: 1}}>
        <Typography variant="h5">{"Thank you for your reservation"}</Typography>
        <Box sx={{ mt:'30px', mb:'30px'}}>
          <Typography >{`Your reservation(${order_number}) has been confirmed for`}</Typography>
          <Typography variant="subtitle2">
            {`${pickup} - ${dropoff} `}
          </Typography>
        </Box>
        <Typography>{"You will receive an email and text message with information on your sheduled delivery and lock information."}</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: '24px' }}>
          {/* <Button
            variant="contained"
            sx={{ padding:'10px 0', width:'150px', textTransform: 'none', fontSize:'16px', marginRight:'40px' }}
            onClick={()=>{
              // redirect("/reservation");
              window.location.href = "/reservation";
            }}
          >
            {"Go Home"}
          </Button> */}
          <Button
            variant="contained"
            sx={{ backgroundColor: "#0047C0", padding:'10px 0', width:'150px', textTransform: 'none', fontSize:'16px' }}
            onClick={()=>{
              localStorage.clear();
              window.location.href = "/rental";
            }}
          >
            {"Log out"}
          </Button>
        </Box>
      </Box>
</Modal>
  );
}

const styles = (matches900: boolean) => ({
  modal: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
  modalContent: {
    width: "100%",
    maxWidth: "960px",
    outline: "none",
    position: "relative",
    display: "flex",
    alignItems: "flex-start",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#0047C0",
    color: "white",
    padding: "9px",
    borderRadius: "9px 9px 0 0",
  },
  modalTitle: {
    fontWeight: 400,
    color: "white",
    fontSize: "18px",
  },
  actionButton: {
    position: "fixed",
    top: "16px",
    right: "16px",
    backgroundColor: "transparent",
    border: "2px solid white",
    borderRadius: "8px",
    padding: "8px 16px",
    cursor: "pointer",
    zIndex: 9999,
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      transform: "scale(1.05)",
    },
  },
  actionButtonText: {
    color: "white",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
    userSelect: "none",
  },
  mainContainer: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  contentContainer: {
    backgroundColor: "white",
    borderRadius: "0px 0px 4px 4px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "column",
    padding: "0",
    overflow: "auto",
    maxHeight: "90vh",
  },
  categoriesContainer: {
    padding: "12px",
    textAlign: "center",
  },
  categoriesTitle: {
    fontWeight: "bold",
    marginBottom: "32px",
    color: "#333",
  },
  categoriesSubtitle: {
    backgroundColor: "#e0e0e0",
    padding: "16px",
    marginBottom: "32px",
    borderRadius: "8px",
    color: "#333",
    fontWeight: 600,
  },
  categoriesGrid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "12px",
    alignItems: "center",
  },
  categoryCard: {
    backgroundColor: "white",
    borderRadius: "4px",
    // padding: '12px',
    cursor: "pointer",
    transition: "all 0.3s ease",
    maxWidth: "295px",
    width: "100%",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  },
  categoryImage: {
    marginBottom: "16px",
  },
  imagePlaceholder: {
    width: "120px",
    height: "120px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    border: "2px solid #ddd",
  },
  imageIcon: {
    width: "60px",
    height: "60px",
    backgroundColor: "#666",
    borderRadius: "8px",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "12px",
      left: "12px",
      width: "12px",
      height: "12px",
      backgroundColor: "#999",
      borderRadius: "50%",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "8px",
      left: "8px",
      width: "0",
      height: "0",
      borderLeft: "20px solid #999",
      borderRight: "20px solid #999",
      borderBottom: "16px solid transparent",
    },
  },
  categoryName: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#333",
  },
  stepperContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    margin: "4px 0px",
    borderRadius: "5px",
    overflow: "hidden"
  },
  stepContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  stepWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    width: "100%",
    padding: "6px"
  },
  stepNumber: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 600,
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  stepLabel: {
    fontSize: "14px",
    whiteSpace: "nowrap",
    transition: "all 0.3s ease",
  },
  connector: {
    flex: 1,
    height: "2px",
    marginLeft: "16px",
    marginRight: "16px",
    transition: "all 0.3s ease",
  },
  container: {
    display: "flex",
    flexDirection: matches900 ? "row" : "column",
    padding: "0",
  },
  ReserveProducts: {
    flex: 1,
    overflow: "auto",
  },
  purchaseContainer: {
    minWidth: matches900 ? "400px" : "100%",
  },
  continueButton: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#0047C0",
    color: "white",
    padding: "12px 24px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "none",
    zIndex: 9999,
    boxShadow: "0 4px 12px rgba(0, 71, 192, 0.3)",
    "&:hover": {
      backgroundColor: "#003399",
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(0, 71, 192, 0.4)",
    },
  },
});

export default Thankyou;
